import React from 'react';

import { ContentBlock, Typography } from '@riac/design-system';
import { usePrefetchSuspense } from 'src/lib/usePrefetch';
import { useFetch } from 'src/lib/FetchContext';
import { NewsCard } from '../NewsCard';

export type RecentEventsViewProps = React.PropsWithChildren<{
  className?: string,
  postType?: 'news' | 'blogs' | 'events' | 'videos' | 'all',
}>;

export const RecentEventsView = (props: RecentEventsViewProps): JSX.Element => {
  const { fetch } = useFetch();
  const events = usePrefetchSuspense('recent-events-view', async () => {
    const eventsReq = await fetch(`/api/ghost/getPostsByPage/0/4/${props.postType || 'all'}`);
    const eventsRes = await eventsReq.json();

    return eventsRes.map((item) => ({
      title: item.title,
      image: item.image,
      date: item.published_at,
      content: `${item.excerpt}...`,
      navigation: item.tags.includes('news') ? `/news/${item.slug}` : item.tags.includes('blogs') ? `/riac-blog/${item.slug}` : item.tags.includes('events') ? `/event/${item.slug}` : item.tags.includes('videos') ? `/video/${item.slug}` : '',
      tags: item.tags,
    }));
  }).read();

  return (
    <div className='flex flex-col gap-10'>
      <div className='flex flex-col gap-3'>
        <Typography weight='medium' align='center' color='text-light'>
          Stay Informed
        </Typography>
        <Typography heading expressive size='xl' align='center' color='text'>
          Latest News
        </Typography>
        <Typography size='lg' color='text' className='max-w-[996px] m-auto' align='center'>
          Find pieces on your favorite rare and historic models, exclusive auction highlights, collecting tips and more.
        </Typography>
      </div>
      <div className = 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[2em]'>
        {events?.map((event, key) => (
          <div className = 'flex flex-col gap-2 p-2 lg:last:hidden' key = {key}>
            <NewsCard
              post={event}
              pageChanging={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
